import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import ThSort from '../common/table/thSort';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import InputPesquisa from '../common/form/inputPesquisa';
import Select from '../common/form/select';
import Aguardando from '../common/template/aguardando';
import FormatUtils from '../common/formatUtils/FormatUtils';
import { getDataHoraFormatada } from '../utils/dataUtils';
import { sortData } from '../common/table/sortHelper';

import criarFormulario from './financeiroForm';
import {
    setModo,
    initForm,
    getLista,
    getOpcoes,
    salvar,
    cancelar
} from './financeiroActions';

const colunas = [
    { field: 'data_vencimento', type: 'date' },
    { field: 'nome_cliente', type: 'text' },
    { field: 'nome_fornecedor', type: 'text' },
    { field: 'descricao', type: 'text' },
    { field: 'nome_plano_conta', type: 'text' },
    { field: 'nome_forma_pagamento', type: 'text' },
    { field: 'valor_original', type: 'number' },
    { field: 'valor_baixado', type: 'number' },
    { field: 'valor_aberto', type: 'number' },
    { field: 'situacao', type: 'text' }
];

const nomesSituacao = {
    ABERTO: 'Aberto',
    PARCIAL: 'Parcial',
    QUITADO: 'Quitado',
    CANCELADO: 'Cancelado',
    VENCIDO: 'Vencido'
};

const nomesOrigem = {
    MANUAL: 'Manual',
    COLETA: 'Coleta',
    APLICACAO: 'Aplicação'
};

const situacoes = [
    { id: 'ABERTO', valor: 'Aberto' },
    { id: 'VENCIDO', valor: 'Vencido' },
    { id: 'PARCIAL', valor: 'Parcial' },
    { id: 'QUITADO', valor: 'Quitado' },
    { id: 'CANCELADO', valor: 'Cancelado' }
];

const moeda = valor =>
    `R$ ${FormatUtils.formatarValorTela(valor || 0, 2)}`;

const data = valor => valor
    ? getDataHoraFormatada(valor, 'DD/MM/YYYY')
    : '-';

const dataInput = dataValor => {
    const ano = dataValor.getFullYear();
    const mes = String(dataValor.getMonth() + 1).padStart(2, '0');
    const dia = String(dataValor.getDate()).padStart(2, '0');

    return `${ano}-${mes}-${dia}`;
};

const periodoMesAtual = () => {
    const hoje = new Date();

    return {
        dataInicial: dataInput(
            new Date(hoje.getFullYear(), hoje.getMonth(), 1)
        ),
        dataFinal: dataInput(
            new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0)
        )
    };
};

const filtrosIniciais = () => ({
    ...periodoMesAtual(),
    idPessoa: null,
    idPlanoConta: null,
    idFormaPagamento: null,
    situacao: null
});

const criarFinanceiro = tipo => {
    const permissao = tipo === 'PAGAR'
        ? 'conta_pagar'
        : 'conta_receber';
    const Formulario = criarFormulario(tipo);

    const Financeiro = props => {
        const [pesquisa, setPesquisa] = useState('');
        const [sort, setSort] = useState({
            field: 'data_vencimento',
            direction: 'asc'
        });
        const [filtros, setFiltros] = useState(filtrosIniciais);

        useEffect(() => {
            props.getLista(tipo);
            props.getOpcoes(tipo);
        }, []);

        const abrir = (modo, registro) => {
            props.setModo(tipo, modo, registro);
            props.initForm(tipo, registro);
        };

        const onSort = field => setSort(anterior => ({
            field,
            direction:
                anterior.field === field &&
                anterior.direction === 'asc'
                    ? 'desc'
                    : 'asc'
        }));

        const termo = pesquisa.trim().toUpperCase();
        const filtrada = (props.lista || []).filter(item => {
            const dataVencimento = item.data_vencimento
                ? item.data_vencimento.toString().substring(0, 10)
                : '';
            const idPessoa = tipo === 'PAGAR'
                ? item.id_fornecedor
                : item.id_cliente;
            const correspondePesquisa = !termo || [
                item.nome_cliente,
                item.nome_fornecedor,
                item.descricao,
                item.nome_plano_conta,
                item.nome_forma_pagamento,
                item.situacao,
                item.origem
            ].join(' ').toUpperCase().includes(termo);

            return correspondePesquisa &&
                (!filtros.dataInicial ||
                    dataVencimento >= filtros.dataInicial) &&
                (!filtros.dataFinal ||
                    dataVencimento <= filtros.dataFinal) &&
                (!filtros.idPessoa ||
                    String(idPessoa) === String(filtros.idPessoa)) &&
                (!filtros.idPlanoConta ||
                    String(item.id_plano_conta) ===
                        String(filtros.idPlanoConta)) &&
                (!filtros.idFormaPagamento ||
                    String(item.id_forma_pagamento) ===
                        String(filtros.idFormaPagamento)) &&
                (!filtros.situacao ||
                    item.situacao === filtros.situacao);
        });
        const lista = sortData(filtrada, sort, colunas);
        const totais = lista.reduce(
            (resultado, item) => {
                if (item.status === 'CANCELADO') {
                    return resultado;
                }

                return {
                    valorOriginal:
                        resultado.valorOriginal +
                        Number(item.valor_original || 0),
                    valorBaixado:
                        resultado.valorBaixado +
                        Number(item.valor_baixado || 0),
                    valorAberto:
                        resultado.valorAberto +
                        Number(item.valor_aberto || 0)
                };
            },
            {
                valorOriginal: 0,
                valorBaixado: 0,
                valorAberto: 0
            }
        );
        const podeIncluir = props.getPermissao(
            permissao,
            ['INCLUSAO']
        );
        const podeAlterar = props.getPermissao(
            permissao,
            ['ALTERACAO']
        );
        const podeExcluir = props.getPermissao(
            permissao,
            ['EXCLUSAO']
        );

        return (
            <Content>
                <Aguardando aguardando={props.aguardando} />

                {props.modo === 'cadastro' &&
                    <Formulario
                        onSubmit={registro =>
                            props.salvar(tipo, registro)}
                    />}

                {props.modo === 'cancelamento' &&
                    <Formulario
                        cancelamento
                        onSubmit={registro =>
                            props.cancelar(tipo, registro)}
                    />}

                {props.modo === 'lista' &&
                    <ContentCard>
                        <ContentCardHeader>
                            <Row>
                                <InputPesquisa
                                    cols='12 6 3 1'
                                    label='Pesquisar'
                                    minWidth={344}
                                    onChange={setPesquisa}
                                />
                                <div style={{ marginTop: 8 }}>
                                    {podeIncluir &&
                                        <button
                                            type='button'
                                            className='btn btn-app bg-success'
                                            onClick={() =>
                                                abrir('cadastro', {})}
                                        >
                                            <i className='fas fa-plus' />
                                            Adicionar
                                        </button>}
                                    <button
                                        type='button'
                                        className='btn btn-app bg-primary'
                                        onClick={() => {
                                            props.getLista(tipo);
                                            props.getOpcoes(tipo);
                                        }}
                                    >
                                        <i className='fas fa-sync-alt' />
                                        Atualizar
                                    </button>
                                </div>
                            </Row>

                            <Row>
                                <Grid cols='12 6 2 2'>
                                    <div className='form-group'>
                                        <label>Vencimento inicial</label>
                                        <input
                                            className='form-control'
                                            type='date'
                                            value={filtros.dataInicial}
                                            onChange={evento =>
                                                setFiltros({
                                                    ...filtros,
                                                    dataInicial:
                                                        evento.target.value
                                                })}
                                        />
                                    </div>
                                </Grid>
                                <Grid cols='12 6 2 2'>
                                    <div className='form-group'>
                                        <label>Vencimento final</label>
                                        <input
                                            className='form-control'
                                            type='date'
                                            value={filtros.dataFinal}
                                            onChange={evento =>
                                                setFiltros({
                                                    ...filtros,
                                                    dataFinal:
                                                        evento.target.value
                                                })}
                                        />
                                    </div>
                                </Grid>
                                <Select
                                    name='filtroPessoa'
                                    options={tipo === 'PAGAR'
                                        ? props.opcoes.fornecedores || []
                                        : props.opcoes.clientes || []}
                                    label={tipo === 'PAGAR'
                                        ? 'Fornecedor'
                                        : 'Cliente'}
                                    cols='12 6 3 3'
                                    value={filtros.idPessoa}
                                    onChange={valor =>
                                        setFiltros({
                                            ...filtros,
                                            idPessoa: valor
                                        })}
                                />
                                <Select
                                    name='filtroPlanoConta'
                                    options={
                                        props.opcoes.planos_contas || []
                                    }
                                    label='Plano de contas'
                                    cols='12 6 3 3'
                                    value={filtros.idPlanoConta}
                                    onChange={valor =>
                                        setFiltros({
                                            ...filtros,
                                            idPlanoConta: valor
                                        })}
                                />
                                <Select
                                    name='filtroFormaPagamento'
                                    options={
                                        props.opcoes.formas_pagamento || []
                                    }
                                    label='Forma de pagamento'
                                    cols='12 6 3 3'
                                    value={filtros.idFormaPagamento}
                                    onChange={valor =>
                                        setFiltros({
                                            ...filtros,
                                            idFormaPagamento: valor
                                        })}
                                />
                                <Select
                                    name='filtroSituacao'
                                    options={situacoes}
                                    label='Situação'
                                    cols='12 6 2 2'
                                    value={filtros.situacao}
                                    onChange={valor =>
                                        setFiltros({
                                            ...filtros,
                                            situacao: valor
                                        })}
                                />
                                <Grid cols='12 6 2 2'>
                                    <button
                                        type='button'
                                        className='btn btn-light'
                                        style={{
                                            width: '100%',
                                            marginTop: 29,
                                            border: '1px solid #cbd5e1'
                                        }}
                                        onClick={() =>
                                            setFiltros(filtrosIniciais())}
                                    >
                                        <i
                                            className='fas fa-eraser'
                                            style={{ marginRight: 7 }}
                                        />
                                        Limpar filtros
                                    </button>
                                </Grid>
                            </Row>
                        </ContentCardHeader>

                        <ContentCardBody>
                            <div
                                style={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    justifyContent: 'flex-end',
                                    gap: 10,
                                    marginBottom: 14
                                }}
                            >
                                {[
                                    {
                                        label: 'Valor total',
                                        valor: totais.valorOriginal
                                    },
                                    {
                                        label: tipo === 'PAGAR'
                                            ? 'Total pago'
                                            : 'Total recebido',
                                        valor: totais.valorBaixado
                                    },
                                    {
                                        label: 'Total em aberto',
                                        valor: totais.valorAberto
                                    }
                                ].map(item => (
                                    <div
                                        key={item.label}
                                        style={{
                                            minWidth: 180,
                                            padding: '12px 14px',
                                            borderRadius: 10,
                                            background: '#f3f7fb',
                                            border: '1px solid #dce3eb',
                                            textAlign: 'center'
                                        }}
                                    >
                                        <small className='text-muted'>
                                            {item.label}
                                        </small>
                                        <div
                                            style={{
                                                fontSize: 18,
                                                fontWeight: 700,
                                                color: '#062042'
                                            }}
                                        >
                                            {moeda(item.valor)}
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <Table responsive border alturaFixa striped>
                                <THead>
                                    <Tr>
                                        <ThSort
                                            field='data_vencimento'
                                            label='Vencimento'
                                            width={110}
                                            sort={sort}
                                            onSort={onSort}
                                        />
                                        <Th alignCenter width={210}>
                                            {tipo === 'PAGAR'
                                                ? 'Fornecedor'
                                                : 'Cliente'}
                                        </Th>
                                        <ThSort
                                            field='descricao'
                                            label='Descrição'
                                            width={230}
                                            sort={sort}
                                            onSort={onSort}
                                        />
                                        <ThSort
                                            field='nome_plano_conta'
                                            label='Plano de contas'
                                            width={190}
                                            sort={sort}
                                            onSort={onSort}
                                        />
                                        <Th alignCenter width={85}>
                                            Parcela
                                        </Th>
                                        <ThSort
                                            field='nome_forma_pagamento'
                                            label='Forma de pagamento'
                                            width={150}
                                            sort={sort}
                                            onSort={onSort}
                                        />
                                        <ThSort
                                            field='valor_original'
                                            label='Valor'
                                            width={110}
                                            sort={sort}
                                            onSort={onSort}
                                        />
                                        <ThSort
                                            field='valor_baixado'
                                            label={tipo === 'PAGAR'
                                                ? 'Pago'
                                                : 'Recebido'}
                                            width={110}
                                            sort={sort}
                                            onSort={onSort}
                                        />
                                        <ThSort
                                            field='valor_aberto'
                                            label='Em aberto'
                                            width={110}
                                            sort={sort}
                                            onSort={onSort}
                                        />
                                        <ThSort
                                            field='situacao'
                                            label='Situação'
                                            width={100}
                                            sort={sort}
                                            onSort={onSort}
                                        />
                                        <Th alignCenter width={90}>
                                            Origem
                                        </Th>
                                        <Th sticky alignCenter width={80} />
                                    </Tr>
                                </THead>

                                <TBody>
                                    {lista.map(item => (
                                        <Tr key={item.id}>
                                            <Td alignCenter>
                                                {data(item.data_vencimento)}
                                            </Td>
                                            <Td alignCenter>
                                                {tipo === 'PAGAR'
                                                    ? item.nome_fornecedor
                                                    : item.nome_cliente}
                                            </Td>
                                            <Td alignCenter>
                                                {item.descricao}
                                            </Td>
                                            <Td alignCenter>
                                                {item.codigo_plano_conta}
                                                {' - '}
                                                {item.nome_plano_conta}
                                            </Td>
                                            <Td alignCenter>
                                                {item.numero_parcela}/
                                                {item.quantidade_parcelas}
                                            </Td>
                                            <Td alignCenter>
                                                {item.nome_forma_pagamento}
                                            </Td>
                                            <Td alignCenter>
                                                {moeda(item.valor_original)}
                                            </Td>
                                            <Td alignCenter>
                                                {moeda(item.valor_baixado)}
                                            </Td>
                                            <Td alignCenter>
                                                {moeda(item.valor_aberto)}
                                            </Td>
                                            <Td alignCenter>
                                                {nomesSituacao[item.situacao] ||
                                                    item.situacao}
                                            </Td>
                                            <Td alignCenter>
                                                {nomesOrigem[item.origem] ||
                                                    item.origem}
                                            </Td>
                                            <Td alignCenter minWidth={90}>
                                                <ButtonTable
                                                    type='warning'
                                                    width={32}
                                                    small
                                                    icon='fas fa-pencil-alt'
                                                    visible={
                                                        podeAlterar &&
                                                        item.status !==
                                                            'CANCELADO'
                                                    }
                                                    title='Editar / baixar'
                                                    event={() =>
                                                        abrir(
                                                            'cadastro',
                                                            item
                                                        )}
                                                />
                                                <ButtonTable
                                                    type='danger'
                                                    width={32}
                                                    small
                                                    icon='fas fa-ban'
                                                    visible={
                                                        podeExcluir &&
                                                        Number(
                                                            item.valor_baixado
                                                        ) === 0 &&
                                                        item.status !==
                                                            'CANCELADO'
                                                    }
                                                    title='Cancelar'
                                                    event={() =>
                                                        abrir(
                                                            'cancelamento',
                                                            item
                                                        )}
                                                />
                                            </Td>
                                        </Tr>
                                    ))}
                                </TBody>
                            </Table>
                        </ContentCardBody>
                    </ContentCard>}
            </Content>
        );
    };

    const chave = tipo === 'PAGAR' ? 'pagar' : 'receber';

    return connect(
        state => ({
            aguardando: state.financeiro.aguardando,
            modo: state.financeiro[chave].modo,
            lista: state.financeiro[chave].lista,
            opcoes: state.financeiro[chave].opcoes || {},
            getPermissao: state.auth.getPermissao
        }),
        dispatch => bindActionCreators({
            setModo,
            initForm,
            getLista,
            getOpcoes,
            salvar,
            cancelar
        }, dispatch)
    )(Financeiro);
};

export default criarFinanceiro;
